/**
 * Platform模块API接口
 */
import request from '@/utils/request'

// ==================== PlatformConfig 平台配置 ====================

/**
 * 获取系统支持的平台列表（枚举）
 */
export function getSupportedPlatforms() {
  return request({
    url: '/PlatformConfig/GetSupportedPlatforms',
    method: 'get'
  })
}

/**
 * 根据平台编码获取配置
 */
export function getPlatformByCode(code) {
  return request({
    url: `/PlatformConfig/GetByCode/${code}`,
    method: 'get'
  })
}

/**
 * 获取所有启用的平台列表
 */
export function getEnabledPlatformList() {
  return request({
    url: '/PlatformConfig/GetEnabledList',
    method: 'get'
  })
}

/**
 * 获取ISV模式的平台列表
 */
export function getIsvPlatformList() {
  return request({
    url: '/PlatformConfig/GetIsvList',
    method: 'get'
  })
}

// ==================== PlatformShop 平台店铺 ====================

/**
 * 根据店铺编码获取店铺
 */
export function getShopByCode(code) {
  return request({
    url: `/PlatformShop/GetByCode/${code}`,
    method: 'get'
  })
}

/**
 * 根据平台编码获取店铺列表
 */
export function getShopsByPlatform(platformCode) {
  return request({
    url: `/PlatformShop/GetByPlatform/${platformCode}`,
    method: 'get'
  })
}

/**
 * 获取启用的店铺列表
 */
export function getEnabledShopList() {
  return request({
    url: '/PlatformShop/GetEnabledList',
    method: 'get'
  })
}

/**
 * 根据公司获取店铺列表
 */
export function getShopsByCompany(companyId, departmentId) {
  let url = `/PlatformShop/GetByCompany/${companyId}`
  if (departmentId) {
    url += `?departmentId=${departmentId}`
  }
  return request({
    url,
    method: 'get'
  })
}

// ==================== PlatformAuth 平台授权 ====================

/**
 * 根据平台和店铺获取授权信息
 */
export function getAuthByShop(platformCode, shopCode) {
  return request({
    url: `/PlatformAuth/GetByShop/${platformCode}/${shopCode}`,
    method: 'get'
  })
}

/**
 * 保存或更新授权信息
 */
export function saveOrUpdateAuth(data) {
  return request({
    url: '/PlatformAuth/SaveOrUpdate',
    method: 'post',
    data
  })
}

/**
 * 刷新访问令牌
 */
export function refreshToken(authId, data) {
  return request({
    url: `/PlatformAuth/RefreshToken/${authId}`,
    method: 'post',
    data
  })
}

/**
 * 获取即将过期的授权列表
 */
export function getExpiringAuths(beforeMinutes = 60) {
  return request({
    url: `/PlatformAuth/GetExpiring?beforeMinutes=${beforeMinutes}`,
    method: 'get'
  })
}

/**
 * 标记授权为无效
 */
export function markAuthInvalid(authId) {
  return request({
    url: `/PlatformAuth/MarkInvalid/${authId}`,
    method: 'post'
  })
}

/**
 * 启动授权流程（获取授权URL）
 */
export function startAuthorize(data) {
  return request({
    url: '/PlatformAuth/StartAuthorize',
    method: 'post',
    data
  })
}

/**
 * 重新授权（获取授权URL）
 */
export function reAuthorize(authId, data) {
  return request({
    url: `/PlatformAuth/ReAuthorize/${authId}`,
    method: 'post',
    data
  })
}

// ==================== PlatformApiLog 平台接口日志 ====================

/**
 * 根据时间范围获取日志
 */
export function getLogsByTimeRange(params) {
  return request({
    url: '/PlatformApiLog/GetByTimeRange',
    method: 'get',
    params
  })
}

/**
 * 根据业务类型和ID获取日志
 */
export function getLogsByBusiness(businessType, businessId) {
  return request({
    url: `/PlatformApiLog/GetByBusiness/${businessType}/${businessId}`,
    method: 'get'
  })
}

/**
 * 获取失败的接口调用日志
 */
export function getFailedLogs(params) {
  return request({
    url: '/PlatformApiLog/GetFailedLogs',
    method: 'get',
    params
  })
}

/**
 * 根据追踪ID获取日志
 */
export function getLogByTraceId(traceId) {
  return request({
    url: `/PlatformApiLog/GetByTraceId/${traceId}`,
    method: 'get'
  })
}

/**
 * 记录API调用日志
 */
export function logApiCall(data) {
  return request({
    url: '/PlatformApiLog/Log',
    method: 'post',
    data
  })
}
